import { createThemeCompiler } from '../../utils';
import { badgeThemeCompiler } from '../../components/badge/theme';
import { buttonThemeCompiler } from '../../components/button/theme';
import { calendarThemeCompiler } from '../../components/calendar/theme';
import { calloutThemeCompiler } from '../../components/callout/theme';
import { carouselThemeCompiler } from '../../components/carousel/theme';
import { checkboxThemeCompiler } from '../../components/checkbox/theme';
import { collapsibleThemeCompiler } from '../../components/collapsible/theme';
import { compactTimePickerThemeCompiler } from '../../components/compact-time-picker/theme';
import { dateRangePickerThemeCompiler } from '../../components/date-range-picker/theme';
import { dropdownThemeCompiler } from '../../components/dropdown/theme';
import { flyoutThemeCompiler } from '../../components/flyout/theme';
import { menuThemeCompiler } from '../../components/menu/theme';
import { messageThemeCompiler } from '../../components/message/theme';
import { numberboxThemeCompiler } from '../../components/numeric-box/theme';
import { popupThemeCompiler } from '../../components/popup/theme';
import { popupMessageThemeCompiler } from '../../components/popup-message/theme';
import { radioButtonThemeCompiler } from '../../components/radio-button/theme';
import { spinnerThemeCompiler } from '../../components/spinner/theme';
import { tabsPanelThemeCompiler } from '../../components/tabs-panel/theme';
import { notificationMessageThemeCompiler } from '../../components/notification/theme';
import { textareaThemeCompiler } from '../../components/textarea/theme';
import { textboxThemeCompiler } from '../../components/textbox/theme';
import { timePickerThemeCompiler } from '../../components/time-picker/theme';
import { treeViewThemeCompilier } from '../../components/tree-view/theme';
import { typographyThemeCompiler } from '../../components/typography/theme';
import { tagInputThemeCompiler } from '../../components/tag-input/theme';
import { iconThemeCompiler } from '../../components/icon/theme';
import { modalThemeCompiler } from '../../components/modal/theme';
import { colorPickerThemeCompiler } from '../../components/color-picker/theme';
import { colorPickerCalloutThemeCompiler } from '../../components/color-picker-callout/theme';
import { progressIndicatorThemeCompiler } from '../../components/progress-indicator/theme';
import { toggleInputThemeCompiler } from '../../components/toggle-input/theme';
import { toolbarThemeCompiler } from '../../components/toolbar/theme';
import { listViewThemeCompiler } from '../../components/listview/theme';
import { maskedInputThemeCompiler } from '../../components/masked-input/theme';
import { richTextEditorThemeCompiler } from '../../components/rich-text-editor/theme';
import { fileUploadThemeCompiler } from '../../components/file-upload/theme';
import { sliderThemeCompiler } from '../../components/slider/theme';
import { ratingThemeCompiler } from '../../components/rating/theme';
import { chartThemeCompiler } from '../../components/chart/theme';

const rootCompiler = createThemeCompiler((semantics) => ({ semantics }));

export const getBaseCompilers = () => [
    rootCompiler, typographyThemeCompiler, badgeThemeCompiler,
    buttonThemeCompiler, checkboxThemeCompiler, textboxThemeCompiler,
    numberboxThemeCompiler, radioButtonThemeCompiler, textareaThemeCompiler,
    tabsPanelThemeCompiler, calloutThemeCompiler, dateRangePickerThemeCompiler,
    spinnerThemeCompiler, treeViewThemeCompilier, dropdownThemeCompiler,
    messageThemeCompiler, menuThemeCompiler, timePickerThemeCompiler,
    notificationMessageThemeCompiler, compactTimePickerThemeCompiler, popupThemeCompiler, calendarThemeCompiler,
    colorPickerThemeCompiler, colorPickerCalloutThemeCompiler, tagInputThemeCompiler,
    flyoutThemeCompiler, iconThemeCompiler, modalThemeCompiler, progressIndicatorThemeCompiler, toggleInputThemeCompiler,
    carouselThemeCompiler, listViewThemeCompiler, collapsibleThemeCompiler,
    popupMessageThemeCompiler, toolbarThemeCompiler, maskedInputThemeCompiler, richTextEditorThemeCompiler,
    fileUploadThemeCompiler, sliderThemeCompiler, ratingThemeCompiler, chartThemeCompiler
];
